import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '../../lib/axios';
import { EQUIPMENT_TABLE_KEY, QUERY_PAGE, QUERY_PER_PAGE, QUERY_SEARCH } from '../../lib/constants';
import { AxiosErrorResponse } from '../../lib/types';
import { ResourceResponse } from '../types';

import { Equipment } from './index';

export const getEquipmentTable = (queryParams: URLSearchParams): Promise<ResourceResponse<Equipment>> => {
  const params = {
    page: queryParams.get(QUERY_PAGE) || 1,
    perPage: queryParams.get(QUERY_PER_PAGE) || 10,
    search: queryParams.get(QUERY_SEARCH) || null,
  };

  return axios.get('/product', { params });
};

export const useEquipmentTable = (args: URLSearchParams) => {
  args.sort();
  return useQuery<ResourceResponse<Equipment>, AxiosError<AxiosErrorResponse>>({
    queryKey: [EQUIPMENT_TABLE_KEY, args.toString()],
    queryFn: () => getEquipmentTable(args),
    keepPreviousData: true,
  });
};
